// extracted by mini-css-extract-plugin
export default {"teacherInstructions":"teacher-instructions_teacherInstructions__BH1Vc","title":"teacher-instructions_title__WSBnv","editable":"teacher-instructions_editable__kaqVL"};